import { ComputeResourceType } from '@cast/shared-types';

import {
  computeResourceUnitsMap,
  computeResourceWordMap,
} from 'constants/maps';

import { ChartWidget } from '../ChartWidget';
import {
  nonPredictionStrokeDasharrayMap,
  percentileToColor,
  percentileToTitle,
} from '../constants';
import { ChartWithPrediction } from './ChartWithPrediction';
import { useWorkloadSelectedContainer } from '../_hooks/useWorkloadSelectedContainer';
import {
  CurrentRequestMetricBox,
  RecommendedMetricBox,
  RecommendedRequestMetricBoxes,
} from '../RecommendedRequestMetricBoxes';
import { UsageMetricsBoxes } from '../UsageMetricsBoxes';
import { useMemoryChartData } from './useMemoryChartData';

export const MemoryChartSection = () => {
  const { container } = useWorkloadSelectedContainer();
  const {
    workload,
    timeZone,
    isFetching,
    error,
    refetch,
    chartData,
    toggleMetric,
    isMetricDisabled,
  } = useMemoryChartData({ container });

  return (
    <ChartWidget
      testId="memory-chart"
      title="Memory"
      chartEl={
        <ChartWithPrediction
          timeZone={timeZone}
          unit="GiB"
          analyzeDescription="VPA memory metric with prediction"
          data={chartData?.chartData ?? []}
          dataKeys={chartData?.chartDataKeys ?? []}
          colorMap={percentileToColor}
          tooltipTitleMap={percentileToTitle}
          strokeDasharrayMap={
            chartData?.isReadOnly ? nonPredictionStrokeDasharrayMap : {}
          }
          isLoading={isFetching || !workload || !chartData}
          hasError={!!error && !isFetching}
          refetch={refetch}
          isMetricDisabled={isMetricDisabled}
        />
      }
      primaryMetricsEl={
        chartData && workload ? (
          <RecommendedRequestMetricBoxes
            showArrow
            currentEl={
              <CurrentRequestMetricBox
                title={`${computeResourceWordMap[ComputeResourceType.MEMORY]} ${
                  percentileToTitle.req
                }`}
                acronym={computeResourceUnitsMap[ComputeResourceType.MEMORY]}
                markerColor={percentileToColor.req}
                from={chartData.requested}
                to={chartData.recommended}
                isDisabled={isMetricDisabled('req')}
                onClick={() => toggleMetric('req')}
              />
            }
            recommendationEl={
              <RecommendedMetricBox
                type={ComputeResourceType.MEMORY}
                title={`${computeResourceWordMap[ComputeResourceType.MEMORY]} ${
                  percentileToTitle.rec
                }`}
                acronym={computeResourceUnitsMap[ComputeResourceType.MEMORY]}
                markerColor={percentileToColor.rec}
                recommendation={workload.recommendation}
                from={chartData.requested}
                to={chartData.recommended}
                isReadOnly={chartData.isReadOnly}
                resourceConfig={workload.workloadConfigV2.vpaConfig.memory}
                isDisabled={isMetricDisabled('rec')}
                onClick={() => toggleMetric('rec')}
              />
            }
          />
        ) : null
      }
      secondaryMetricsEl={
        chartData ? (
          <UsageMetricsBoxes
            unit="GiB"
            metricsBoxes={['max', 'p75', 'p50', 'min']}
            titleMap={percentileToTitle}
            colorMap={percentileToColor}
            summary={chartData.aggregated}
            toggleMetricsBox={toggleMetric}
            isMetricDisabled={isMetricDisabled}
            fullWidth
          />
        ) : undefined
      }
    />
  );
};
